<template>
    <section class="row mt-3 section-news">
        <div class="container" v-if="inFetching">
            <div class="row">
                <div class="col-12 text-center">
                    <div class="spinner-grow text-danger" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="container" v-else>
            <div class="row mt-3 text-justify news-content" v-html="content"></div>
        </div>
    </section>
</template>

<script>
    import * as _ from 'lodash';

    export default {
        name: "ProvisionComponent",
        data() {
            return {
                inFetching: false,
                content: ''
            }
        },
        async mounted() {
            // set inFetching mode
            this.inFetching = true;

            // get provision configuration item
            let provisionConfigItem = _.find(this.$store.state.configurations.configurationsList, function(configItem) {
                return configItem.configId === process.env.VUE_APP_PROVISION_CONFIG_ID;
            });

            // set page content
            this.content = provisionConfigItem.configValue;

            // release inFetching mode
            this.inFetching = false;
        }
    }
</script>

<style scoped>

</style>
